import { registerSW } from 'virtual:pwa-register'

export function registerPwa(showStatus: (message: string) => void, canActivate: () => boolean): void {
  const updateServiceWorker = registerSW({
    immediate: true,
    onOfflineReady() {
      showStatus('OFFLINE CORE READY')
    },
    onNeedRefresh() {
      const activateWhenSafe = (): void => {
        if (canActivate()) {
          showStatus('UPDATING SYSTEM CORE')
          void updateServiceWorker(true)
        } else {
          window.setTimeout(activateWhenSafe, 1_000)
        }
      }
      activateWhenSafe()
    },
    onRegisterError() {
      showStatus('OFFLINE CACHE UNAVAILABLE - LOCAL PLAY ENABLED')
    },
  })
}
